module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0699.1e503da4.jpg";